import React from 'react';

import http from 'api/http';
import { boatAPI, manufacturerAPI, trailerAPI } from 'api/requests';

import { downloadFile } from 'helpers';

import Pagination from 'Components/Pagination';
import RowsSelector from 'Components/RowsSelector';
import EmptyList from 'Components/EmptyList';
import FiltersSection from './FiltersSection';
import TableHeader from './TableHeader';
import Row from './Row';
import Store from '../../../registerIDBWorker';
import { Input, inputStyleClasses } from 'Components/Input';
import { ROLES } from 'constants/roles';

const SEARCHABLE_FIELDS = ['fileName', 'typeTitle'];

export default class DocumentsList extends React.Component {
  defaultState = {
    activePage: 1,
    selectedRowsCount: 10,
    status: 'All',
    selectedType: 'All',
    sortedBy: 'fileName',
    sortAsc: -1,
    filter: {},
    searchString: '',
    currentYear: '',
    chosenYear: ''
  };

  constructor(props) {
    super(props);

    const storedState = props.user.getStoredState('documentsListState', this.defaultState);
    props.user.updateURLSearchString(storedState);

    this.state = {
      ...this.defaultState,
      ...storedState
    };

    this.listRequestInProgress = true;
    this.engineTypes = [];
    this.documentsList = [];
    this.documentTypes = ['All'];
  }

  roleSwitch = () => {
    const {user, match} = this.props;

    let URLRole = '';

    Object.keys(ROLES).forEach(roleKey => {
      if (match.params.manufacturerRole === ROLES[roleKey].nameForUrl) URLRole = ROLES[roleKey];
    });

    if (URLRole && user.getActiveRole() !== URLRole.serverName) {
      user.changeMenu(URLRole.serverName);
    }
  };

  componentDidMount() {
    const {user} = this.props;

    this.roleSwitch();

    this.currentRole = user.getActiveRole();

    this.getCurrentYear()
      .then(currentYear => {
        this.setState({currentYear}, () => {
          this.handleYearSelect(user.getSelectedYear() || currentYear);
        });
      });
  }

  updateListData() {
    const {user} = this.props;
    const {chosenYear} = this.state;

    this.currentRole = user.getActiveRole();
    this._loadFromStore();

    http.get(manufacturerAPI.eSignDocumentsList(chosenYear, this.currentRole))
      .then(({data}) => {
        Store.insert(`${this.currentRole}_documents`, data, `${user.getManufacturerCode()}${chosenYear}`)
          .then(() => {
            this.listRequestInProgress = false;
            this._loadFromStore();
          });
      });
  }

  componentDidUpdate() {
    const {user} = this.props;

    if (user.getActiveRole() !== this.currentRole) {
      this.documentsList = [];
      this.listRequestInProgress = true;
      this.getCurrentYear()
        .then(currentYear => {
          this.setState({currentYear}, () => {
            this.handleYearSelect(user.getSelectedYear() || currentYear);
          });
        });
    }
  }

  getCurrentYear = () => {
    const {user} = this.props;

    return (new Promise((resolve, reject) => {
      switch (user.getActiveRole()) {
        case ROLES.BOAT_MANUFACTURER.serverName:
          http.get(boatAPI.currentModelYear)
            .then(({data}) => {
              resolve(data[1] || data[0]);
            });
          break;
        case ROLES.COMPONENT_MANUFACTURER.serverName:
          http.get(boatAPI.currentModelYear)
            .then(({data}) => {
              resolve(data[1] || data[0]);
            });
          break;
        case ROLES.TRAILER_MANUFACTURER.serverName:
          http.get(trailerAPI.currentModelYear)
            .then(({data}) => {
              resolve(data);
            });
          break;
        default:
          resolve(new Date().getFullYear());
          break;
      }
    }));
  };

  _loadFromStore = () => {
    const {user} = this.props;
    const {chosenYear} = this.state;

    Store.select(`${user.getActiveRole()}_documents`, `${user.getManufacturerCode()}${chosenYear}`)
      .then(list => {
        this.documentsList = list;
        this.initDocumentTypes(list);
        this.forceUpdate();
      });
  };

  initDocumentTypes = data => {
    this.documentTypes = ['All'];
    let allPossibleDocumentTypes = {};

    data.forEach(documentEntry => {
      allPossibleDocumentTypes[documentEntry.typeTitle] = true;
    });

    Object.keys(allPossibleDocumentTypes).forEach(type => {
      this.documentTypes.push(type);
    });
  };

  componentWillUnmount() {
    const {user} = this.props;

    user.saveState('documentsListState', this.state, ['chosenYear']);
  }

  handleRowsSelect = (rowsCountSelected, totalRowsCount) => {
    const {user} = this.props;

    const selectedRowsCount = (rowsCountSelected && rowsCountSelected < totalRowsCount) ? rowsCountSelected : 0;

    const state = {selectedRowsCount, activePage: 1};
    this.setState(state, user.updateURLSearchString(state));
  };

  handleActivePageChange = activePage => {
    const {user} = this.props;

    this.setState({activePage}, () => {user.updateURLSearchString({activePage});});
  };

  _filterList = componentList => {
    const {filter, searchString} = this.state;

    const doesSearchableFieldsContainSearchString = (element) => {
      for (let searchableFieldIndex in SEARCHABLE_FIELDS) {
        if (element[SEARCHABLE_FIELDS[searchableFieldIndex]]) {
          if (element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase()
            .includes(searchString.toLowerCase())) return true;
        }
      }
      return false;
    };

    return componentList.filter(element => {
      for (let filterFieldName in filter) {
        switch (filterFieldName) {
          case 'status':
            if (element[filterFieldName].toLowerCase() !== filter[filterFieldName].toLowerCase()) return false;
            break;
          default:
            if (element[filterFieldName] !== filter[filterFieldName]) return false;
        }
      }
      return (!searchString || doesSearchableFieldsContainSearchString(element));
    });
  };

  _sortList = (a, b) => {
    const {sortedBy, sortAsc} = this.state;

    switch (sortedBy) {
      default:
        if (a[sortedBy] && b[sortedBy]) return a[sortedBy].toString().toLowerCase().replace(/\s+/g, ' ') > b[sortedBy].toString().toLowerCase().replace(/\s+/g, ' ') ? sortAsc : -sortAsc;
        else return a[sortedBy] > b[sortedBy] ? sortAsc : -sortAsc;
    }
  };

  handleSort = sortedBy => () => {
    const {user} = this.props;

    this.setState(prevState => ({sortedBy, sortAsc: -prevState.sortAsc, activePage: 1}), () => {
      user.updateURLSearchString({sortedBy: this.state.sortedBy, sortAsc: this.state.sortAsc, activePage: 1});
    });
  };

  handleSelectFilter = filterFieldName => filterElement => {
    const {user} = this.props;
    const selectedValue = filterElement.value !== undefined ? filterElement.value : filterElement;
    let newFilterState = this.state.filter;

    if (selectedValue === 'All') delete newFilterState[filterFieldName];
    else newFilterState[filterFieldName] = selectedValue;

    this.setState({filter: newFilterState, activePage: 1}, () => {
      user.updateURLSearchString({
        filter: this.state.filter,
        activePage: 1
      });
    });
  };

  handleSearchStringInput = value => {
    const {user} = this.props;
    this.setState({searchString:value, activePage:1}, () => {user.updateURLSearchString({searchString:value});});
  };

  handleYearSelect = year => {
    const {user} = this.props;

    user.saveSelectedYear(year);
    this.setState({chosenYear: year},
      () => {
        this.listRequestInProgress = true;
        user.updateURLSearchString({chosenYear: year});
        this.updateListData();
      });
  };

  handleDownloadClick = (envelopeId, name) => () => {
    http.get(manufacturerAPI.eSignDocumentDownload(envelopeId, name), {
      responseType: 'blob'
    })
      .then(({data}) => {
        downloadFile(data, name);
      });
  };

  _getList = () => {
    const {activePage, selectedRowsCount, sortedBy} = this.state;
    const {user} = this.props;

    let resultList = [];
    let resultLength = 0;

    if (!this.documentsList.length) {
      if (this.listRequestInProgress) {
        resultList = [
          <div key='no-spinner-div' className='ect-spinner _height_120'>
            <div className='ect-spinner__image' style={{width: 50, height: 50}} />
          </div>
        ];
      } else {
        resultList = [
          <EmptyList key={0}>
            No documents for selected manufacturer.
          </EmptyList>
        ];
      }
    } else {
      const filteredList = this._filterList(this.documentsList).sort(this._sortList);
      const sliceFrom = (activePage - 1) * selectedRowsCount;
      const sliceTo = +selectedRowsCount ? activePage * selectedRowsCount : filteredList.length;

      if (!filteredList.length) {
        resultList = [
          <EmptyList key={0}>
            No documents found with selected filters.
          </EmptyList>
        ];
      } else {
        resultList = filteredList.slice(sliceFrom, sliceTo).map((document, index) => {
          return (
            <Row
              key={document.id}
              user={user}
              document={document}
              isOdd={!!(index % 2)}
              sortedBy={sortedBy}
              handleDownloadClick={this.handleDownloadClick}
            />
          );
        });
        resultLength = filteredList.length;
      }
    }

    return {
      resultList,
      resultLength
    };
  };

  render() {
    const {activePage, selectedRowsCount, sortedBy, sortAsc, filter, searchString, currentYear, chosenYear} = this.state;
    const {resultList, resultLength} = this._getList();

    return (
      <section className='scene__scene-wrapper'>
        <section className='scene__content-wrapper list-scene__content-wrapper'>
          <header className='scene__scene-header list-scene__scene-header'>
            Documents
            <Input
              mainWrapperClassName='list-scene__header-search-field-wrapper'
              styleClass={inputStyleClasses.searchBar}
              placeholder='Type here to search'
              maxLength={250}
              value={searchString}
              onChange={this.handleSearchStringInput}
            />
          </header>
          <FiltersSection
            outCount={resultLength}
            handleRowCountSelect={this.handleRowsSelect}
            rowsCount={selectedRowsCount}
            handleSelectFilter={this.handleSelectFilter}
            handleYearSelect={this.handleYearSelect}
            filterState={filter}
            chosenYear={chosenYear}
            currentYear={currentYear}
            documentTypes={this.documentTypes}
          />
          <TableHeader handleSortClick={this.handleSort} order={sortAsc === 1} sortedBy={sortedBy} />
          {resultList}
          <footer className='list-scene__footer'>
            <RowsSelector
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
              handleRowsSelect={this.handleRowsSelect}
            />
            <Pagination
              className='_height_80'
              activePage={activePage}
              handleClick={this.handleActivePageChange}
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
            />
          </footer>
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/DocumentsList/index.jsx